import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Bet, Stage } from '../domain/Bet.domain'

interface DeleteProofPointInput {
  id: string
  betId: string
  stage: Stage
}

export const useDeleteProofPoint = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: DeleteProofPointInput) => {
      await api.delete(`/proof-points/${id}`)
    },
    onMutate: async ({ id, betId, stage }) => {
      await queryClient.cancelQueries({ queryKey: [QueryKeys.Bets] })
      const previous = queryClient.getQueryData<Bet[]>([QueryKeys.Bets])
      queryClient.setQueryData<Bet[]>([QueryKeys.Bets], (old) =>
        old?.map((b) =>
          b.id === betId
            ? { ...b, [stage]: b[stage].filter((p) => p.id !== id) }
            : b
        )
      )
      return { previous }
    },
    onError: (_err, _vars, context) => {
      queryClient.setQueryData([QueryKeys.Bets], context?.previous)
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Bets] })
    },
  })
}
